/* KIDSpo グローバルメニュー: メガ(PC) + 全画面(モバイル) */
(function () {
  'use strict';

  /* ---------- desktop mega ---------- */
  var nav = document.querySelector('[data-kidspo-nav]');
  var mega = document.querySelector('[data-kidspo-mega]');
  var hideTimer;

  function clearOpen() {
    if (!nav) return;
    nav.querySelectorAll('[data-kidspo-open]').forEach(function (b) {
      b.classList.remove('is-open');
      b.setAttribute('aria-expanded', 'false');
    });
  }
  function showPanel(id, btn) {
    if (!mega) return;
    clearTimeout(hideTimer);
    mega.querySelectorAll('[data-kidspo-panel]').forEach(function (p) {
      p.hidden = p.getAttribute('data-kidspo-panel') !== id;
    });
    clearOpen();
    if (btn) { btn.classList.add('is-open'); btn.setAttribute('aria-expanded', 'true'); }
    mega.classList.add('is-show');
  }
  function hideMega() {
    hideTimer = setTimeout(function () {
      if (mega) mega.classList.remove('is-show');
      clearOpen();
    }, 130);
  }

  if (nav) {
    nav.querySelectorAll('[data-kidspo-open]').forEach(function (btn) {
      var id = btn.getAttribute('data-kidspo-open');
      btn.addEventListener('mouseenter', function () { showPanel(id, btn); });
      btn.addEventListener('focus', function () { showPanel(id, btn); });
      btn.addEventListener('click', function (e) { e.preventDefault(); showPanel(id, btn); });
    });
    nav.querySelectorAll('a.kidspo-nav__item').forEach(function (a) {
      a.addEventListener('mouseenter', hideMega);
      a.addEventListener('focus', hideMega);
    });
    nav.addEventListener('mouseleave', hideMega);
  }
  if (mega) {
    mega.addEventListener('mouseenter', function () { clearTimeout(hideTimer); });
    mega.addEventListener('mouseleave', hideMega);
  }
  window.addEventListener('scroll', function () {
    if (mega && mega.classList.contains('is-show')) { mega.classList.remove('is-show'); clearOpen(); }
  }, { passive: true });

  /* ---------- mobile full-screen menu ---------- */
  var mmenu = document.querySelector('[data-kidspo-mmenu]');
  var openers = document.querySelectorAll('[data-kidspo-menu-open]');
  var lastFocus = null;

  function openMenu() {
    if (!mmenu) return;
    lastFocus = document.activeElement;
    mmenu.hidden = false;
    document.body.classList.add('kidspo-menu-lock');
    requestAnimationFrame(function () { mmenu.classList.add('is-open'); });
    openers.forEach(function (o) { o.setAttribute('aria-expanded', 'true'); });
    var first = mmenu.querySelector('input, a[href], button');
    if (first) { try { first.focus(); } catch (e) {} }
  }
  function closeMenu() {
    if (!mmenu) return;
    mmenu.classList.remove('is-open');
    document.body.classList.remove('kidspo-menu-lock');
    openers.forEach(function (o) { o.setAttribute('aria-expanded', 'false'); });
    setTimeout(function () { mmenu.hidden = true; }, 300);
    if (lastFocus) { try { lastFocus.focus(); } catch (e) {} }
  }
  openers.forEach(function (o) { o.addEventListener('click', openMenu); });
  document.querySelectorAll('[data-kidspo-menu-close]').forEach(function (c) {
    c.addEventListener('click', closeMenu);
  });

  if (mmenu) {
    mmenu.querySelectorAll('[data-kidspo-acc]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var id = btn.getAttribute('data-kidspo-acc');
        var panel = document.getElementById('kidspo-acc-' + id);
        var open = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', open ? 'false' : 'true');
        if (panel) panel.hidden = open;
      });
    });
  }

  /* ---------- keyboard: ESC + focus trap ---------- */
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      if (mmenu && !mmenu.hidden) closeMenu();
      if (mega && mega.classList.contains('is-show')) { mega.classList.remove('is-show'); clearOpen(); }
    }
    if (e.key === 'Tab' && mmenu && !mmenu.hidden) {
      var f = mmenu.querySelectorAll('a[href], button:not([disabled]), input, [tabindex]:not([tabindex="-1"])');
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });
})();
